/**
 * author       : zwl
 * createTime   : 2018/6/8 上午9:11
 * description  :
 */
import api from 'axios'
import NProgress from 'nprogress'
import store from '@/store/store'
// import router from '@/router/router'
import {Message} from 'element-ui'
import { getToken, removeToken, refreshTokenIsUse, tokenIsUse } from 'util/auth'

api.defaults.timeout = 10000
api.defaults.headers.post['Content-Type'] = 'application/json'
api.defaults.baseURL = '/api'
window.isRefreshing = false
let refreshSubscribers = []

function subscribeTokenRefresh (cb) {
  refreshSubscribers.push(cb)
}

function onRrefreshed (token) {
  refreshSubscribers.map(cb => cb(token))
}

function _checkTime (time) {
  let sysDate = new Date(time).getTime()
  let browserDate = new Date().getTime()
  if (Math.abs(sysDate - browserDate) > 600000) {
    Message({
      message: '系统时间与实际时间不符，可能导致货源不同步，请校准！',
      type: 'warning',
      duration: 5 * 1000
    })
  }
}

api.interceptors.request.use((config) => {
  NProgress.start()
  config.headers['Authorization'] = 'bearer ' + getToken().accessToken
  if (!tokenIsUse()) {
    if (!window.isRefreshing) {
      window.isRefreshing = true
      store.dispatch('refreshUserToken').then((data) => {
        window.isRefreshing = false
        onRrefreshed(data.data.access_token)
        refreshSubscribers = []
      }).catch(() => {
        window.isRefreshing = false
        setTimeout(() => {
          window.location.href = '/login'
        }, 1000)
        // router.push('/login')
        Message({
          message: '登录失效，请重新登录',
          type: 'error',
          duration: 5 * 1000
        })
        NProgress.done()
      })
    }
    let retry = new Promise((resolve, reject) => {
      subscribeTokenRefresh((token) => {
        config.headers.Authorization = 'Bearer ' + token
        resolve(config)
      })
    })
    return retry
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

api.defaults.retry = 1
api.defaults.retryDelay = 9000

api.interceptors.response.use(
  response => {
    NProgress.done()
    if (response.data.status === 0) {
      if (response.data.msg) {
        Message({
          message: response.data.msg,
          type: 'success',
          duration: 5 * 1000
        })
      }
      return response
    } else {
      Message({
        message: response.data.msg,
        type: 'warning',
        duration: 5 * 1000
      })
      return false
    }
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          if (refreshTokenIsUse()) {
            store.dispatch('refreshUserToken')
          } else {
            // router.push('/login')
            setTimeout(() => {
              window.location.href = '/login'
            }, 1000)
            console.log('过期')
            removeToken()
          }
          // 401 清除token信息并跳转到登录页面
          break
        case 403:
          // 403 无权限，跳转到首页
          Message({
            message: '您没有权限！需要操作请联系管理员！',
            type: 'warning',
            duration: 5 * 1000
          })
          break
        case 500:
          let msg
          if (!error.response.data.msg) {
            msg = '服务器链接异常，请稍后再试！'
          } else {
            msg = error.response.data.msg
          }
          Message({
            message: msg,
            type: 'error',
            duration: 5 * 1000
          })
          break
      }
    } else if (error.request) {
      var config = error.config
      config.__retryCount = config.__retryCount || 0
      if (config.__retryCount >= config.retry) {
        Message({
          message: '请求超时，请稍后重试',
          type: 'error',
          duration: 5 * 1000
        })
        NProgress.done()
        return Promise.reject(error)
      }
      config.__retryCount += 1
      var backoff = new Promise(function (resolve) {
        setTimeout(function () {
          resolve()
        }, config.retryDelay || 1)
      })
      return backoff.then(function () {
        config.baseURL = ''
        return api(config)
      })
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    NProgress.done()
    return Promise.reject(error)
  })

export default api
